import { render, staticRenderFns } from "./blind.vue?vue&type=template&id=83c3f2f4&scoped=true"
import script from "./blind.vue?vue&type=script&lang=js"
export * from "./blind.vue?vue&type=script&lang=js"
import style0 from "./blind.vue?vue&type=style&index=0&id=83c3f2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c3f2f4",
  null
  
)

export default component.exports